"use client";

var _excluded = ["expandedIndex", "expandedIndexes", "multiExpanded", "onExpanderToggled", "children"];

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];

  if (null != _i) {
    var _s,
        _e,
        _x,
        _r,
        _arr = [],
        _n = !0,
        _d = !1;

    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) {
        ;
      }
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React, { useEffect, useState } from "react";

function computeExpandedListFromProps(_ref) {
  var expandedIndex = _ref.expandedIndex,
      expandedIndexes = _ref.expandedIndexes,
      multiExpanded = _ref.multiExpanded;

  if (Array.isArray(expandedIndexes) && multiExpanded) {
    return expandedIndexes;
  }

  if (typeof expandedIndex === "number") {
    return [expandedIndex];
  }

  return [];
}

var ExpanderGroup = function ExpanderGroup(props) {
  var expandedIndex = props.expandedIndex,
      expandedIndexes = props.expandedIndexes,
      _props$multiExpanded = props.multiExpanded,
      multiExpanded = _props$multiExpanded === void 0 ? false : _props$multiExpanded,
      onExpanderToggled = props.onExpanderToggled,
      children = props.children,
      otherProps = _objectWithoutProperties(props, _excluded);

  var initialState = computeExpandedListFromProps(props);

  var _useState = useState(initialState),
      _useState2 = _slicedToArray(_useState, 2),
      expandedList = _useState2[0],
      setExpandedList = _useState2[1];

  function handleToggleExpander(idx) {
    var isAlreadyExpanded = expandedList.includes(idx);
    onExpanderToggled && onExpanderToggled(idx, isAlreadyExpanded ? "collapsed" : "expanded");

    if (multiExpanded) {
      var indexes = isAlreadyExpanded ? expandedList.filter(function (i) {
        return i !== idx;
      }) : [].concat(_toConsumableArray(expandedList), [idx]);
      setExpandedList(indexes);
    } else {
      setExpandedList(isAlreadyExpanded ? [] : [idx]);
    }
  }

  useEffect(function () {
    var newState = computeExpandedListFromProps({
      expandedIndex: expandedIndex,
      expandedIndexes: expandedIndexes,
      multiExpanded: multiExpanded
    });
    setExpandedList(newState);
  }, [expandedIndex, expandedIndexes, multiExpanded]);
  var childrenWithProps = React.Children.map(children, function (child, idx) {
    if (! /*#__PURE__*/React.isValidElement(child)) {
      return null;
    }

    return /*#__PURE__*/React.cloneElement(child, {
      expanded: expandedList.includes(idx),
      onToggleExpanded: function onToggleExpanded() {
        return handleToggleExpander(idx);
      }
    });
  });
  return /*#__PURE__*/React.createElement("div", otherProps, childrenWithProps);
};

export default ExpanderGroup;